var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25991 25.8333H25.8332C26.258 25.8114 26.6715 25.6882 27.0389 25.474C27.4064 25.2598 27.7173 24.9607 27.9457 24.6019C28.1741 24.243 28.3133 23.8347 28.3517 23.4111C28.3901 22.9874 28.3267 22.5607 28.1666 22.1666L23.4999 14L18.8332 5.83331C18.6026 5.41651 18.2646 5.06909 17.8542 4.82716C17.4439 4.58524 16.9763 4.45764 16.4999 4.45764C16.0236 4.45764 15.5559 4.58524 15.1456 4.82716C14.7352 5.06909 14.3972 5.41651 14.1666 5.83331L4.83324 22.1666C4.67316 22.5607 4.60969 22.9874 4.64811 23.4111C4.68653 23.8347 4.82574 24.243 5.05411 24.6019C5.28248 24.9607 5.59339 25.2598 5.96088 25.474C6.32836 25.6882 6.74177 25.8114 7.16658 25.8333",
    stroke: "#DD4242",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.1667V17.1667M16.5 21.1667V20.5",
    stroke: "#DD4242",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9c2886d2.svg";
export { ForwardRef as ReactComponent };